import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import VueRouter from 'vue-router'
import routes from './routes';

require('./bootstrap');

window.axios = require('axios');
window.Vue = require('vue');
Vue.config.productionTip = false;

// Initialize Vuetiify
const vuetifyOptions = {};

Vue.use(Vuetify);
Vue.use(VueRouter);

Vue.component('permit-index', require('./components/Permits/IndexComponent').default);
Vue.component('permit-create', require('./components/Permits/CreateComponent').default);

Vue.component('admin-index', require('./components/Admin/IndexComponent').default);

Vue.component('receipt-index', require('./components/receipts/IndexComponent.vue').default);
Vue.component('receipt-show', require('./components/receipts/ShowComponent.vue').default);

Vue.component('user-impersonate', require('./components/impersonate/IndexComponent.vue').default);
Vue.component('ticket-payment', require('./components/ticket-payment/Index.vue').default);


const app = new Vue({
    el: '#app',
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    router: new VueRouter(routes),
    vuetify: new Vuetify(vuetifyOptions),
});
